module.exports = __webpack_public_path__ + "img/planet2.60827325.png";